import FieldContainer from "../../shared/containers/form/FieldContainer";
import { Label } from "../../shared/components/form/Layout";
import { Field, Form } from "react-final-form";
import Input from "../../shared/components/form/Input";
import ErrorContainer from "../../shared/containers/form/ErrorContainer";
import PhoneNumberInput from "../../shared/components/form/PhoneNumberInput";
import CountrySelector from "../../shared/components/form/CountrySelector";
import SimpleSelect from "../../shared/components/form/SimpleSelect";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { editAccountInitialValues, getUser } from "../../../data/account/selectors/user";
import { useTranslation } from "react-i18next";
import { validate, validatePro } from "../../../data/account/validators/account";
import { updateAccount } from "../../../data/account/actions/account";
import { FormHeading } from "../../shared/components/Typograhy";
import { ButtonArea, NextButton } from "../../shared/components/Buttons";
import Divider from "../../shared/components/Divider";
import { Alert } from "../../shared/components/Alert";
import * as customerTypes from "../../../data/booking/constants/customer_types";
import ImageUploadWithPreview from "./ImageUploadWithPreview";
import { Button } from "../../shared/components/Buttons";
import { submitFirstSignIn } from '../../../data/account/actions/firstSignIn';



const AccountForm = () => {
    const { t } = useTranslation();
    const initialValues = useSelector((state) =>
        editAccountInitialValues(getUser(state))
    );
    const updateStatus = useSelector((state) => state.account.userSession.update.result);
    const { data } = useSelector(state => state.account.userSession);
    const { success } = useSelector(state => state.account.firstSignIn);
    const [notification, setNotification] = useState(false);
    const dispatch = useDispatch();

    return (
        <div className={"mx-auto max-w-4xl"}>
            <FormHeading
                title={t("account_button.my_account")}
                subtitle={t('account_button.subtitle_my_account')}
            />
            {notification && updateStatus == 'success' && <Alert alert="success">{t('account_button.update_success')}</Alert>}
            {notification && updateStatus == 'error' && <Alert alert="danger">{t('account_button.update_failure')}</Alert>}
            <Form
                onSubmit={(values) => {
                    return dispatch(updateAccount(values))
                }}
                validate={data && customerTypes.BUSINESS === data.type ? validatePro : validate}
                initialValues={initialValues}
            >
                {({ handleSubmit, pristine, form, submitting, invalid, values, validating }) => {
                    const country = values['country']

                    return (
                        <form className="mt-8" onSubmit={(e) => {
                            handleSubmit(e).then(() => {
                                form.reset({
                                    ...form.getState().values,
                                    password: null
                                })
                                form.resetFieldState('password');
                                setNotification(true)
                            })
                        }}>
                            <div className={"space-y-8"}>
                                {/*<Divider className={"my-8"}>Identité</Divider>*/}
                                {data && customerTypes.BUSINESS === data.type && (<>
                                    <section className="flex flex-col items-center sm:gap-4">
                                        <Label htmlFor="agencyImage">{t('account_button.business_logo')} :</Label>
                                        <Field
                                            id="agencyImage"
                                            name="agencyImage"
                                            component={ImageUploadWithPreview} />
                                    </section>
                                    <section className="sm:flex sm:gap-16">
                                        <div className="sm:w-full">
                                            <FieldContainer name="agencyName">
                                                <Label
                                                    htmlFor="agencyName"
                                                    className="col-xs-3"
                                                >
                                                    {t('account_button.business_name')} * :{" "}
                                                </Label>
                                                <div className="col-xs-8 no-padding">
                                                    <Field
                                                        className="form-control"
                                                        id="agencyName"
                                                        name="agencyName"
                                                        type="text"
                                                        component={Input}
                                                    />
                                                    <ErrorContainer name="agencyName" />
                                                </div>
                                            </FieldContainer>
                                        </div>
                                    </section>
                                </>)}
                                <section className="sm:flex sm:gap-16">
                                    <div className="sm:w-1/2">
                                        <FieldContainer name="firstName">
                                            <Label
                                                htmlFor="firstName"
                                                className="col-xs-3"
                                            >
                                                {t('account_button.first_name')} * :{" "}
                                            </Label>
                                            <div className="col-xs-8 no-padding">
                                                <Field
                                                    className="form-control"
                                                    id="firstName"
                                                    name="firstName"
                                                    type="text"
                                                    component={Input}
                                                    disabled={!data.password}
                                                />
                                                <ErrorContainer name="firstName" />
                                            </div>
                                        </FieldContainer>
                                    </div>
                                    <div className="mt-8 sm:mt-0 sm:w-1/2">
                                        <FieldContainer name="lastName">
                                            <Label
                                                htmlFor="lastName"
                                                className="col-xs-7"
                                            >
                                                {t('account_button.last_name')} * :{" "}
                                            </Label>
                                            <div className="col-xs-5 no-padding">
                                                <Field
                                                    className="form-control"
                                                    id="lastName"
                                                    name="lastName"
                                                    type="text"
                                                    component={Input}
                                                    disabled={!data.password}
                                                />
                                            </div>
                                            <ErrorContainer name="lastName" />
                                        </FieldContainer>
                                    </div>
                                </section>
                                {/*<Divider>Identifiant et moyens de communication</Divider>*/}
                                <section className="sm:flex sm:gap-16">
                                    <div className="sm:w-1/2">
                                        <FieldContainer name="email">
                                            <Label htmlFor="email" className="col-xs-7">
                                                {t('account_button.username_or_email')} * :{" "}
                                            </Label>
                                            <div className="col-xs-5 no-padding">
                                                <Field
                                                    className="form-control"
                                                    id="email"
                                                    name="email"
                                                    type="email"
                                                    component={Input}
                                                    disabled={!data.password}
                                                />
                                            </div>
                                            <ErrorContainer name="email" />
                                        </FieldContainer>
                                    </div>
                                    <div className="mt-8 sm:mt-0 sm:w-1/2">
                                        <FieldContainer name="phoneNumber">
                                            <Label
                                                htmlFor="phoneNumber"
                                                className="col-xs-7"
                                            >
                                                {t("account_button.phone")} * :{" "}
                                            </Label>
                                            <div className="col-xs-5 no-padding">
                                                <Field
                                                    className="input-lg disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 disabled:ring-gray-200"
                                                    id="phoneNumber"
                                                    name="phoneNumber"
                                                    placeholder={t(
                                                        "account_button.phone"
                                                    )}
                                                    component={PhoneNumberInput}
                                                    disabled={!data.password}
                                                />
                                            </div>
                                            <ErrorContainer name="phoneNumber" />
                                        </FieldContainer>
                                    </div>
                                </section>
                                {/*<Divider>Informations supplémentaires</Divider>*/}
                                <section className="sm:flex sm:gap-16">
                                    <div className="sm:w-1/2">
                                        <FieldContainer name="language">
                                            <Label htmlFor="language">{t('account_button.language')} : </Label>

                                            <Field
                                                className="form-control"
                                                id="language"
                                                name="language"
                                                component={SimpleSelect}
                                                disabled={!data.password}
                                            >
                                                <option value="fr">Français</option>
                                                <option value="en">English</option>
                                                <option value="de">Deutsh</option>
                                            </Field>

                                            <ErrorContainer name="language" />
                                        </FieldContainer>
                                    </div>
                                    <div className="mt-8 sm:mt-0 sm:w-1/2">
                                        <FieldContainer name="country">
                                            <Label htmlFor="country">
                                                {t("account_button.country")} :{" "}
                                            </Label>
                                            <div>
                                                <Field
                                                    id="country"
                                                    name="country"
                                                    placeholder={t(
                                                        "account_button.country"
                                                    )}
                                                    onChange={() => { }}
                                                    component={CountrySelector}
                                                    disabled={!data.password}
                                                />
                                            </div>
                                            <ErrorContainer name="country" />
                                        </FieldContainer>
                                    </div>
                                    {(country && country.value == 'FR') && <div className="mt-8 sm:mt-0 sm:w-1/2">
                                        <FieldContainer name="postalCode">
                                            <Label htmlFor="postalCode">
                                                {t("account_button.postal_code")} :{" "}
                                            </Label>
                                            <div>
                                                <Field
                                                    id="postalCode"
                                                    name="postalCode"
                                                    placeholder="43000"
                                                    type="number"
                                                    component={Input}
                                                    disabled={!data.password}
                                                />
                                            </div>
                                            <ErrorContainer name="postalCode" />
                                        </FieldContainer>
                                    </div>}
                                </section>
                                <section className="sm:flex sm:gap-16">
                                    <FieldContainer name="optIn">
                                        <div className="checkbox">
                                            <label htmlFor="optInForNewsletter" className="align-middle">
                                                <Field
                                                    id="optInForNewsletter"
                                                    name="optInForNewsletter"
                                                    className="mr-0.5 h-4 w-4 rounded border-stone-400 text-orange-600 focus:ring-orange-500"
                                                    component="input"
                                                    disabled={!data.password}
                                                    type="checkbox" />
                                                {' '}{t('account_button.optin')}.
                                            </label>
                                        </div>
                                    </FieldContainer>
                                </section>
                                <Divider>{t("account_button.dataInvoice")}</Divider>
                                {data && customerTypes.BUSINESS === data.type && (<>
                                    <section className="sm:flex sm:gap-16">
                                        <div className="mt-8 sm:mt-0 sm:w-1/2">
                                            <FieldContainer name="billingName">
                                                <Label
                                                    htmlFor="billingName"
                                                    className="col-xs-7"
                                                >
                                                    {t('account_button.last_name')} * :{" "}
                                                </Label>
                                                <div className="col-xs-5 no-padding">
                                                    <Field
                                                        className="form-control"
                                                        id="billingName"
                                                        name="billingName"
                                                        type="text"
                                                        component={Input}

                                                    />
                                                </div>
                                                <ErrorContainer name="billingName" />
                                            </FieldContainer>
                                        </div>
                                        <div className="mt-8 sm:mt-0 sm:w-1/2">
                                            <FieldContainer name="billingEmail">
                                                <Label
                                                    htmlFor="billingEmail"
                                                    className="col-xs-7"
                                                >
                                                    {t('account_button.email')} :{" "}
                                                </Label>
                                                <div className="col-xs-5 no-padding">
                                                    <Field
                                                        className="form-control"
                                                        id="billingEmail"
                                                        name="billingEmail"
                                                        type="text"
                                                        component={Input}
                                                    />
                                                </div>
                                                <ErrorContainer name="billingEmail" />
                                            </FieldContainer>
                                        </div>
                                    </section>
                                </>)}
                                <section className="sm:flex sm:gap-16">
                                    <div className="sm:w-full">
                                        <FieldContainer name="billingAddress">
                                            <Label htmlFor="billingAddress">{t('account_button.address')} * : </Label>

                                            <Field
                                                className="form-control"
                                                id="billingAddress"
                                                name="billingAddress"
                                                component={Input}
                                                disabled={!data.password}
                                            />
                                            <ErrorContainer name="billingAddress" />
                                        </FieldContainer>
                                    </div>
                                </section>
                            </div>
                            {data.password ? <>
                                <Divider>{t('account_button.indentity_comfirmation')}</Divider>

                                <div className="mt-8 mb-4">
                                    <p className="mt-1 text-sm text-gray-500">
                                        {t('account_button.comfirm_update')}
                                    </p>
                                </div>

                                <section className="sm:flex sm:gap-16">
                                    <FieldContainer name="password">
                                        <Label htmlFor="password" className="col-xs-7">
                                            {t("account_button.password")} :{" "}
                                        </Label>
                                        <Field
                                            id="password"
                                            autoComplete="new-password"
                                            name="password"
                                            placeholder={t("account_button.password")}
                                            component={Input}
                                            type="password"
                                        />
                                        <ErrorContainer name="password" />
                                    </FieldContainer>
                                </section>
                                <ButtonArea>
                                    <NextButton
                                        classname="ml-auto"
                                        loading={validating || submitting}
                                        disabled={pristine || submitting || invalid || validating}
                                        type="submit"
                                    >
                                        {t('account_button.update')}
                                    </NextButton>
                                </ButtonArea>
                            </> :
                                <div className="flex flex-col items-center mt-4 py-2 px-3 border text-justify bg-stone-100 rounded-md">
                                    <p className="my-2">
                                        {`${t('account_button.password_needed')} ${t('account_button.send_email_for_password_1')}`} <strong>{data.contact.email ? data.contact.email : ""}</strong> {t('account_button.send_email_for_password_2')}
                                    </p>
                                    {success &&
                                        <>
                                            <div className="bg-green-100  border-green-300 p-4 w-full mt-2 mb-2 rounded-md text-center" role="alert">
                                                <p>{`${t('account_button.send_email_success_1')} ${data.contact.email} !`}</p>
                                                <p>{t('account_button.send_email_success_2')}</p>
                                                <p>{t('account_button.see_you_soon')}</p>
                                            </div>
                                        </>
                                    }

                                    <Button onClick={() => { dispatch(submitFirstSignIn(data.contact.email)) }}
                                        icon={"paper-plane"}
                                        className="p-3 rounded-md bg-orange-500 text-white hover:bg-orange-500"
                                    >
                                        {"Crée un mot de passe"}
                                    </Button>

                                </div>
                            }
                        </form>
                    );
                }}
            </Form>
        </div >
    );
};
export default AccountForm;
